import type * as React from "react";
import { cn } from "./cn";

/** A placeholder block while data loads; hidden from assistive technologies. */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden
      className={cn("animate-pulse rounded-sm bg-hover", className)}
      {...props}
    />
  );
}

export { Skeleton };
